import { pushToDataLayer } from './pushToDataLayer';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import {
  CovideoGTMVideoAttributes,
  CovideoGTMVideoMessageProperties,
  GTMCDKUserAttributes,
  GTMEvent,
  GTMPageApplication,
  GTMPageviewAttributes,
  GTMVehicleAttributes,
  GTMVideoAttributes,
  GTMVideoMessageProperties,
} from './types';
import {
  mapToGtmVehicleAttributes,
  mapToGTMVideoAttributes,
  mapToGtmVideoMessageProperties,
} from './utils';

import { isCdkEnvironment } from 'utils/constants';
import { InventoryItem } from 'types';

// userData does not exist since CDK session are anonymous?!
// we can't provide video attributes from here either since we need to extend api
export function useGTMTrackPageView() {
  const location = useLocation();

  // actions
  const trackVideoSpecificPagesManually = useCallback(
    ({
      pageLocation,
      pageSection,
      videoAttributes,
      inventoryItem,
      videoMessageProperties,
      userData,
    }: {
      pageLocation?: string;
      pageSection?: string;
      videoAttributes?: CovideoGTMVideoAttributes;
      videoMessageProperties?: CovideoGTMVideoMessageProperties;
      inventoryItem?: InventoryItem;
      userData: {
        cdkStoreId?: string;
        cdkEnterpriseId?: string;
      };
    }) => {
      const gtmVideoAttributes: GTMVideoAttributes =
        mapToGTMVideoAttributes(videoAttributes);

      const vehicleData: GTMVehicleAttributes =
        mapToGtmVehicleAttributes(inventoryItem);

      const gtmVideoMessageProperties: GTMVideoMessageProperties =
        mapToGtmVideoMessageProperties(videoMessageProperties);

      const cdkUserAttributes: GTMCDKUserAttributes = {
        enterprise_id: userData?.cdkEnterpriseId || undefined,
        store_id: userData?.cdkStoreId || undefined,
      };

      const pageViewAttributes: GTMPageviewAttributes = {
        event: GTMEvent.COVIDEO_PAGEVIEW,
        application: GTMPageApplication.CRM_VIDEO_ADMIN,
        page_url: window.location.href,
        page_location: pageLocation || undefined,
        page_section: pageSection || undefined,
      };

      const payload = {
        ...pageViewAttributes,
        ...cdkUserAttributes,
        ...gtmVideoAttributes,
        ...vehicleData,
        ...gtmVideoMessageProperties,
      };

      pushToDataLayer(payload);
    },
    [location.pathname]
  );

  return {
    trackVideoSpecificPagesManually: isCdkEnvironment
      ? trackVideoSpecificPagesManually
      : undefined,
  };
}
